import { render, staticRenderFns } from "./updateStock.vue?vue&type=template&id=4a0f548f&"
import script from "./updateStock.vue?vue&type=script&lang=js&"
export * from "./updateStock.vue?vue&type=script&lang=js&"
import style0 from "./updateStock.vue?vue&type=style&index=0&id=4a0f548f&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a0f548f')) {
      api.createRecord('4a0f548f', component.options)
    } else {
      api.reload('4a0f548f', component.options)
    }
    module.hot.accept("./updateStock.vue?vue&type=template&id=4a0f548f&", function () {
      api.rerender('4a0f548f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/inventory/products/updateStock.vue"
export default component.exports